import { ValidationResult } from './validation-result';
import { FormControl, AbstractControl } from '@angular/forms';

export class EqualValidator {

    public static validaIgualdade(fc: FormControl): ValidationResult {

        const a: AbstractControl = fc.root.get('senha');
        const c: AbstractControl = fc.root.get('confirmarSenha');
        
        if (a && c && a.value !== c.value && c.value) {

            if(!a.value || !c.value) {
                return null;
            }

            return {'valorDiferente': true};
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/equal-validator.ts